import { UAParser } from 'ua-parser-js';

export const getIsWindowsOs = () => {
  if (window.electron?.isWindows) {
    return true;
  }

  const parser = new UAParser();
  return !!parser.getResult().os.name?.toLowerCase().includes('windows');
};
